/* eslint-disable max-classes-per-file */
import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class AddKundorderradAlternativaHandelssortimentCommand extends BasicCommand<AddKundorderradAlternativaHandelssortimentCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<AddKundorderradAlternativaHandelssortimentCommand>;
    kundorderradId: number;
    handelssortiment: Handelssortiment[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "KundorderAlteranativthandelssortiment";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "AddKundorderradAlternativaHandelssortimentCommand";
    constructor(kundorderradId: number) {
        super("AddKundorderradAlternativaHandelssortimentCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}

export class Handelssortiment {
    id?: number;
    handelssortimentId: number;
    manuellPaArbetsorder: boolean;
    egenskapskodX: boolean;
    endastCentralaKop: boolean;
    inmatningshandelssortimentId: number;
    clientIdGuid: string;
}
